import {
  ConsultaSeguimentoPergunta15Model,
  ConsultaSeguimentoPergunta15TentaImitarEnum,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-15/model-consultaSeguimentoPergunta15'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta15Model {
  header: MchatRfAplicacaoQueryModel
  tentaImitar: MchatRfAplicacaoQueryModel[]
  model: ConsultaSeguimentoPergunta15Model
}

export const convertAplicacaoPergunta15 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta15Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_15_01)
  const tentaImitar = aplicacoes.filter((aplicacao) => PERGUNTA_15_TENTA_IMITAR.includes(aplicacao.pergunta))
  const outro = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_15_08)

  if (header === undefined) return null

  return {
    header,
    tentaImitar,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_15_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_15_TENTA_IMITAR: convertAplicacoesToTentaImitar(tentaImitar),
      OUTRO: {
        radioValue: booleanToSimNaoEnum(outro?.stPassou),
        textValue: outro?.outros ?? undefined,
      },
    },
  }
}

const convertAplicacoesToTentaImitar = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta15TentaImitarEnum, ReturnType<typeof booleanToSimNaoEnum>> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta15TentaImitarEnum, ReturnType<typeof booleanToSimNaoEnum>>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_TENTA_IMITAR }
  )

const PERGUNTA_15_TENTA_IMITAR = [
  MChatPerguntaEnum.PERGUNTA_15_02,
  MChatPerguntaEnum.PERGUNTA_15_03,
  MChatPerguntaEnum.PERGUNTA_15_04,
  MChatPerguntaEnum.PERGUNTA_15_05,
  MChatPerguntaEnum.PERGUNTA_15_06,
  MChatPerguntaEnum.PERGUNTA_15_07,
  MChatPerguntaEnum.PERGUNTA_15_08,
]

const EMPTY_TENTA_IMITAR: Record<ConsultaSeguimentoPergunta15TentaImitarEnum, undefined> = {
  [ConsultaSeguimentoPergunta15TentaImitarEnum.POE_LINGUA_PRA_FORA]: undefined,
  [ConsultaSeguimentoPergunta15TentaImitarEnum.FAZ_SOM_ENGRACADO]: undefined,
  [ConsultaSeguimentoPergunta15TentaImitarEnum.DA_TCHAU]: undefined,
  [ConsultaSeguimentoPergunta15TentaImitarEnum.BATE_PALMAS]: undefined,
  [ConsultaSeguimentoPergunta15TentaImitarEnum.COLOCA_DEDOS_NOS_LABIOS]: undefined,
  [ConsultaSeguimentoPergunta15TentaImitarEnum.MANDA_BEIJO]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta15TentaImitarEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_15_02]: ConsultaSeguimentoPergunta15TentaImitarEnum.POE_LINGUA_PRA_FORA,
  [MChatPerguntaEnum.PERGUNTA_15_03]: ConsultaSeguimentoPergunta15TentaImitarEnum.FAZ_SOM_ENGRACADO,
  [MChatPerguntaEnum.PERGUNTA_15_04]: ConsultaSeguimentoPergunta15TentaImitarEnum.DA_TCHAU,
  [MChatPerguntaEnum.PERGUNTA_15_05]: ConsultaSeguimentoPergunta15TentaImitarEnum.BATE_PALMAS,
  [MChatPerguntaEnum.PERGUNTA_15_06]: ConsultaSeguimentoPergunta15TentaImitarEnum.COLOCA_DEDOS_NOS_LABIOS,
  [MChatPerguntaEnum.PERGUNTA_15_07]: ConsultaSeguimentoPergunta15TentaImitarEnum.MANDA_BEIJO,
}
